import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable } from 'rxjs';
import { UserModel } from '@app/users/shared/user.model';
import { ContactService } from './contact.service';

@Injectable({
  providedIn: 'root',
})
export class ContactResolver {
  constructor(private service: ContactService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<UserModel> {
    return this.service.getById(route.paramMap.get('id') || '').pipe(map((user) => user.data));
  }
}
